import React, { useRef } from 'react';

// The chosen tab is kept for the browser session, like a list's own period and search.
export function loadTab(storageKey, keys, fallback = 'all') {
	try { const v = sessionStorage.getItem(storageKey); return keys.includes(v) ? v : fallback; } catch (e) { return fallback; }
}
export function storeTab(storageKey, key) {
	try { sessionStorage.setItem(storageKey, key); } catch (e) { /* storage blocked */ }
}

// New UI: status tabs with counts over one list (docs/ui_redesign/14-screen-concepts.md, Invoices option A and
// Payment dashboard option B). A tab only chooses which of the list's own rows are shown; the list keeps its data,
// columns and actions. Arrow keys, Home and End move between tabs, as in the dashboard's queue tabs.
export default function StatusTabs({ tabs, value, onChange, label, controls }) {
	const refs = useRef({});
	const onKey = e => {
		const i = tabs.findIndex(t => t.key === value);
		const to = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
		if (to == null) return;
		e.preventDefault();
		const next = tabs[(to + tabs.length) % tabs.length];
		onChange(next.key);
		if (refs.current[next.key]) refs.current[next.key].focus();
	};
	return (
		<div className="apw2-stabs" role="tablist" aria-label={label} onKeyDown={onKey}>
			{tabs.map(t => {
				const on = t.key === value;
				return (
					<button type="button" role="tab" key={t.key} id={'apw2-stab-' + t.key} aria-selected={on} aria-controls={controls}
						tabIndex={on ? 0 : -1} ref={el => { refs.current[t.key] = el; }} className={on ? 'on' : ''} onClick={() => onChange(t.key)}>
						{t.label}
						{t.count != null && <span className={'n' + (t.tone === 'bad' && t.count ? ' bad' : '')}>{t.count}</span>}
					</button>
				);
			})}
		</div>
	);
}
